import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { HttpModule }  from '@angular/http';
import { LoginRoutingModule } from './login-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { LoginService } from '../../shared/_services/login.service';

@NgModule({
  imports: [
  CommonModule,
  SharedModule,
  LoginRoutingModule
  ],
  declarations: [LoginComponent],
  providers: [LoginService]
})
export class LoginModule { }



// WEBPACK FOOTER //
// ./src/app/components/login/login.module.ts